/**
 * Mechagora theme — public API.
 *
 * Structure (all under shared/theme):
 *   systems/     craft presets + token constants
 *   catalog.ts   preset registry
 *   provider/    ThemeProvider + useTheme
 *   components/  ThemeSelector, ThemeSwitcher, ThemeStudio, ThemeToggle
 *   client/      account preference store + types
 *   persistence/ FOUC local cache only
 */

export {
  useTheme,
  ThemeProvider,
  ThemeToggle,
  type ThemeMode,
  type ThemeType,
  type ColorTheme,
  type MechagoraThemeContext,
  ThemeProvider as default,
} from './provider/ThemeProvider'

export { ThemeSelector } from './components/ThemeSelector'
export type { ThemeSelectorProps, ThemeSelectorVariant } from './components/ThemeSelector'
export { ThemeSwitcher } from './components/ThemeSwitcher'
export { ThemeStudio } from './components/ThemeStudio'

export {
  THEME_CATALOG,
  THEME_REGISTRY,
  DEFAULT_COLOR_THEME,
  VALID_PRESET_IDS,
  VALID_COLOR_THEMES,
  listThemeCatalog,
  getThemeCatalogEntry,
  resolveColorTheme,
  isPresetThemeId,
  isValidColorTheme,
} from './catalog'
export type { ThemeCatalogEntry, ThemeSwatches, PresetThemeId } from './catalog'

export {
  MECHAGORA_DARK,
  MECHAGORA_LIGHT,
  MIDNIGHT_SLATE,
  CREAM_PAPER,
  ACCESSIBLE_SIGNALS,
  tokensFromMechagora,
  tokensFromMidnight,
  tokensFromCream,
  type DeskTokenSet,
} from './systems/desk-tokens'

export type {
  ClientThemePreference,
  CustomDeskSystem,
  ThemeSystemRef,
} from './client/preference-types'
